module.exports = __webpack_public_path__ + "img/aji_mgm_cotai.72dd7fc0.jpg";